import { render, staticRenderFns } from "./CampaignBase.vue?vue&type=template&id=389352a2&"
import script from "./CampaignBase.vue?vue&type=script&lang=js&"
export * from "./CampaignBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports